module.exports = __webpack_public_path__ + "img/frown.a5b19a1d.svg";